module.exports = __webpack_public_path__ + "media/images/logos/disney_logo-db68ac66f72ec8b1476a1c59fdf65adf.png";